import { BannerType, ContentFulScreens, ICustomizedBanner } from "@next-platform/client-common-core";
import appLogger from "@next-platform/client-common-core/logger/appLogger";

import { BANNER_STORAGE_KEY, ClosedBannersMap } from "./setClosedBannersInSessionStorage";

const logger = appLogger.withTag("filterClosedBannersFromSession");

const filterClosedBannersFromSession = (
  contentFulScreen: ContentFulScreens,
  placement: BannerType,
  banners: ICustomizedBanner[],
): ICustomizedBanner[] => {
  try {
    const stored = sessionStorage.getItem(BANNER_STORAGE_KEY);
    const closedBanners: ClosedBannersMap = stored ? JSON.parse(stored) : {};

    const closedBannerNames: string[] = closedBanners?.[contentFulScreen]?.[placement] || [];

    const filteredBanners = banners?.filter((banner) => !closedBannerNames.includes(banner?.name));

    return filteredBanners;
  } catch (error) {
    logger.error("Failed to fetch or parse closed banners from sessionStorage:", error);
    return banners;
  }
};

export default filterClosedBannersFromSession;
